import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
};

const dropdownStyle = {
  border: '1px solid lightgray',
  marginTop: 5,
  position: 'absolute',
  width: '100%',
  maxHeight: '205px',
  overflow: 'scroll',
  zIndex: '99',
};

const wrapperStyle = {
  position: 'relative',
  display: 'inline-block',
};

class AutoComplete extends Component {
  render() {
    const {
      getItemValue,
      renderItem,
      onChange,
      onSelect,
      shouldItemRender,
      label,
      data,
      value,
    } = this.props;
    return (
      <div style={containerStyle}>
        <label htmlFor="states-autocomplete">{label}</label>
        <Autocomplete
          renderMenu={children => (
            <div style={children.length ? dropdownStyle : { display: 'none' }}>{children}</div>
          )}
          wrapperStyle={wrapperStyle}
          inputProps={{ id: 'states-autocomplete', className: 'form-control' }}
          getItemValue={getItemValue}
          items={data}
          renderItem={renderItem}
          value={value}
          onChange={onChange}
          onSelect={onSelect}
          shouldItemRender={shouldItemRender}
        />
      </div>
    );
  }
}

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/entry/AutoComplete.js